import React from 'react';
import { createUseStyles } from 'hoi-poi-ui';
import styles from "./styles/drawerContent";
import classnames from 'classnames';
const name = 'DrawerContent';
const useStyles = createUseStyles(styles, 'DrawerContent');
function DrawerContent(_ref) {
  let {
    className,
    children
  } = _ref;
  const classes = useStyles();
  const rootClassName = classnames(classes.root, className);
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.scroll
  }, children));
}
process.env.NODE_ENV !== "production" ? DrawerContent.propTypes = {} : void 0;
const component = /*#__PURE__*/React.memo(DrawerContent);
component.displayName = name;
export default component;